import { Component, inject, Input, OnInit } from '@angular/core';
import { IProduct } from '../../../services/ecosystems/products/IProduct';
import { EdroNetworkManager } from '../../../services/ecosystems/manager/edro-network-manager';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
  DeviceTableNodePresence,
  IDeviceTableNode,
} from '../../../services/ecosystems/products/IDeviceTable';
import moment from 'moment/moment';
import {
  getDataValue,
  getDataValueFromList,
  getMinutesValue,
  isSupportTechnique,
} from '../../../services/ecosystems/ECoSystemsHelper';
import { UserContextService } from '../../../services/user-context.service';
import { IonItem, IonLabel, IonList } from '@ionic/angular/standalone';

@Component({
  selector: 'app-function-parameters-product',
  templateUrl: './function-parameters-product.component.html',
  styleUrls: ['./function-parameters-product.component.scss'],
  imports: [IonItem, IonLabel, IonList, TranslatePipe],
})
export class FunctionParametersProductComponent implements OnInit {
  private edroNetworkManager = inject(EdroNetworkManager);

  public translate = inject(TranslateService);

  @Input() productClass: IProduct | null = null;

  public deviceTableData: IDeviceTableNode | null = null;

  ngOnInit() {
    this.deviceTableData = this.productClass!.getProductDeviceTableFromPool(
      this.edroNetworkManager.getPoolContext().pool!,
    ) as IDeviceTableNode;
  }

  getInstallationDate() {
    if (
      this.edroNetworkManager.getPoolContext().pool?.deviceTable[
        this.productClass!.dataIdentifier!
      ].installationDate
    ) {
      return moment(
        this.edroNetworkManager.getPoolContext().pool?.deviceTable[
          this.productClass!.dataIdentifier!
        ].installationDate,
      ).format('DD/MM/YYYY');
    }

    return '-';
  }

  protected readonly isSupportTechnique = isSupportTechnique;
  protected readonly UserContextService = UserContextService;
  protected readonly Number = Number;
  protected readonly getDataValue = getDataValue;
  protected readonly DeviceTableNodePresence = DeviceTableNodePresence;
  protected readonly getDataValueFromList = getDataValueFromList;
  protected readonly getMinutesValue = getMinutesValue;
}
